var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"waiting-notification shadowed"},[_c('p',{staticClass:"title"},[_vm._v(_vm._s(_vm.$t("utils.youAreFast")))]),_c('p',{staticClass:"subtitle"},[_vm._v(_vm._s(_vm.$t("utils.waitingGroup")))])])
}
var staticRenderFns = []

export { render, staticRenderFns }